import React from 'react';
import { EditorProvider } from '@tiptap/react';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import Document from '@tiptap/extension-document';
import ListItem from '@tiptap/extension-list-item';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Heading from '@tiptap/extension-heading';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import Placeholder from '@tiptap/extension-placeholder';
import { css } from '@emotion/react';

const getExtensions = (placeholderText?: string) => [
  BulletList,
  OrderedList,
  Document,
  ListItem,
  Paragraph,
  Text,
  Bold,
  Italic,
  Link,
  Underline,
  Heading.configure({
    levels: [1, 2, 3]
  }),
  Placeholder.configure({ placeholder: placeholderText || '' })
];

const ReadOnlyNotes = ({ value, placeholder }: { value?: string; placeholder?: string }) => {
  const extensions = getExtensions(placeholder);
  return (
    <div
      css={css`
        border: 1px solid black;
        max-width: 100%;
        width: 100%;
        .tiptap {
          margin: 1em 0;
          p,
          h1,
          h2,
          h3 {
            line-height: 1.42;
            tab-size: 4;
            white-space: pre-wrap;
            word-wrap: break-word;
            font-family: Helvetica, Arial, sans-serif;
            margin: 0 8px;
            padding: 0;
            font-weight: 500;
          }
          p {
            font-size: 13px;
          }
          h1 {
            font-size: 2em;
          }
          h2 {
            font-size: 1.5em;
          }
          h3 {
            font-size: 1.17em;
          }
        }
        p.is-editor-empty:first-child::before {
          content: attr(data-placeholder);
          float: left;
          pointer-events: none;
          height: 0;
          font-size: 12px;
          font-style: italic;
          line-height: 18px;
          color: var(--black);
          opacity: 0.3;
      `}
    >
      <EditorProvider content={value} extensions={extensions} editable={false} />
    </div>
  );
};

export default ReadOnlyNotes;
